
import { useState, useCallback } from 'react';


const MODAL_PRIORITY: Record<string, number> = {
  'ml': 1,
  'apps': 2,
};


type UseModalQueueReturn = {
  queue: string[];
  current: string | undefined;
  enqueue: (key: string) => void;
  dequeue: (key: string) => void;
};

const useModalQueue = (): UseModalQueueReturn => {
  const [queue, setQueue] = useState<string[]>([]);

  const enqueue = useCallback(
    (key: string) => {
      setQueue(prevQueue => {
        // Remove if already exists
        const filtered = prevQueue.filter(itemKey => itemKey !== key);
        // Add new key
        const updated = [...filtered, key];
        // Sort by priority if key is known, otherwise keep at end
        updated.sort((a, b) => {
          const aPriority = MODAL_PRIORITY[a] ?? Number.MAX_SAFE_INTEGER;
          const bPriority = MODAL_PRIORITY[b] ?? Number.MAX_SAFE_INTEGER;
          return aPriority - bPriority;
        });
        return updated;
      });
    },
    []
  );

  const dequeue = useCallback((key: string) => {
    setQueue(prevQueue => prevQueue.filter(itemKey => itemKey !== key));
  }, []);

  const current = queue.length > 0 ? queue[0] : undefined;

  return { queue, current, enqueue, dequeue };
};

export default useModalQueue;